import { makeStyles } from '@mui/styles';
import { DataGrid as MuiDataGrid, useGridApiRef } from '@mui/x-data-grid';
import { frFR } from '@mui/x-data-grid/locales';
import React, { ComponentProps } from 'react';

import { CustomPagination } from '#app/Component/DataGrid/CustomPagination';
import { styleDataGridDefault } from '#app/Style/styleDataGridDefault';
import { Pagination, Sorting } from '#app/typings/utils';

type Props = Omit<ComponentProps<typeof MuiDataGrid>, 'pagination'> & {
  pagination?: Pagination;
  sorting?: Sorting;
  setPagination?: (pagination: Pagination) => void;
  setSorting?: (sorting: Sorting) => void;
};

const DataGrid: React.FC<Props> = ({ pagination, sorting, setPagination, setSorting, sx, slots, ...props }) => {
  const classes = useStyles();
  const apiRef = useGridApiRef();

  return (
    <div className={classes.container}>
      <MuiDataGrid
        localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
        apiRef={apiRef}
        sx={{ ...styleDataGridDefault, ...sx }}
        rowHeight={30}
        disableRowSelectionOnClick
        disableColumnMenu
        slots={{
          pagination: CustomPagination,
          ...slots,
        }}
        sortingMode={setSorting ? 'server' : 'client'}
        sortModel={
          sorting?.sortName && sorting?.sortDirection
            ? [{ field: sorting.sortName, sort: sorting.sortDirection }]
            : undefined
        }
        onSortModelChange={(sort) => {
          if (setSorting) {
            setSorting({ sortName: sort[0]?.field, sortDirection: sort[0]?.sort as 'asc' | 'desc' });
          }
          if (setPagination && pagination) {
            setPagination({ page: 0, limit: pagination.limit });
          }
        }}
        paginationMode={setPagination ? 'server' : 'client'}
        paginationModel={pagination ? { pageSize: pagination.limit ?? 25, page: pagination.page ?? 0 } : undefined}
        onPaginationModelChange={
          setPagination ? ({ pageSize, page }) => setPagination({ page, limit: pageSize }) : undefined
        }
        {...props}
      />
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
});

export default DataGrid;
